import { EMessageChannel } from 'src/services/api';

/**
 * Full channel name, matching the wording of the message composer's channel picker.
 */
export function getChannelLabel(channel: EMessageChannel): string {
    switch (channel) {
        case EMessageChannel.EMAIL:
            return 'Email';
        case EMessageChannel.SMS:
            return 'Text Message';
        case EMessageChannel.FACEBOOK_MESSENGER:
            return 'Facebook Messenger';
        default: {
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            const _assertNever: never = channel;
            return 'Unknown';
        }
    }
}
